<template>
    <div class="selector" :style="{ background: enabled === false && 'none' }">
        <div @click="onclickPanel" style="height: 100%">
            <span class="color-block">
                <div class="color-block-bg"></div>
                <div class="color-block-cell" :style="{ backgroundColor: hexColor }"></div>
            </span>
            <span class="color-label">{{ colorLabel }}</span>
            <span class="color-drop" v-if="enabled !== false"></span>
        </div>
        <div ref="colorpicker_wrapper" class="wrapper" v-show="colorPanelVisible" @mousedown.self="onmousedownWrapper"></div>
        <sketch-color ref="colorpicker" v-show="colorPanelVisible" :value="colorObject" @input="onColorChanged" class="wrapper-color"></sketch-color>
    </div>
</template>

<script>
let vueColor = require('vue-color');
const $ = require('jquery');

if (vueColor == null) {
    vueColor = window.VueColor;
}
if (vueColor == null && window.parent != null) {
    vueColor = window.parent.VueColor;
}
const sketch = vueColor.Sketch;
const defaultPresetColors = sketch.data().presetColors;

function offsetPosition(el) {
    // const pos = {
    //     left: el.offsetLeft,
    //     top: el.offsetTop,
    // };
    // // eslint-disable-next-line no-cond-assign
    // while ((el = el.offsetParent) != null) {
    //     pos.left += el.offsetLeft;
    //     pos.top += el.offsetTop;
    // }

    // return pos;
    return el.getBoundingClientRect();
}

function getRgba(hex) {
    const r = /^#([\dA-Fa-f]{2})([\dA-Fa-f]{2})([\dA-Fa-f]{2})$/.exec(hex);
    if (r == null) {
        return { r: 0, g: 0, b: 0, a: 1 };
    }
    return {
        r: parseInt(r[1], 16),
        g: parseInt(r[2], 16),
        b: parseInt(r[3], 16),
        a: 1,
    };
}

module.exports = {
    props: {
        value: [String, Object],
        presets: Array,
        transparent: Boolean,
        enabled: null,
        window: null,
    },
    data() {
        if (this.transparent && (this.value == null || this.value.length === 0)) {
            return {
                colorPanelVisible: false,
                colorObject: {
                    hex: 'None',
                    rgba: { r: 0, g: 0, b: 0, a: 0 },
                },
            };
        }
        let val = this.value || '#000000';
        if (val.length > 7) {
            val = `#${val.substring(3)}`;
        }
        return {
            colorPanelVisible: false,
            colorObject: {
                hex: val,
                rgba: getRgba(val),
            },
        };
    },
    computed: {
        hexColor() {
            const rgba = this.colorObject.rgba || { r: 0, g: 0, b: 0, a: 1 };
            return `rgba(${rgba.r}, ${rgba.g}, ${rgba.b}, ${rgba.a})`;
        },
        colorLabel() {
            const color = this.colorObject.hex;
            const c = this.presets.filter(v => v.color === color);
            return c && c.length > 0 ? c[0].text : color; // 'Custom';
        },
    },
    components: {
        'sketch-color': sketch,
    },
    mounted() {
        if (this.presets != null) {
            this.$refs.colorpicker.presetColors = this.presets.map(c => c.color);
        }
        // move element to the body
        $(this.$refs.colorpicker_wrapper).detach();
        $((this.window || window).document.body).append(this.$refs.colorpicker_wrapper);
        $(this.$refs.colorpicker.$el).detach();
        $((this.window || window).document.body).append(this.$refs.colorpicker.$el);
    },
    watch: {
        presets(v) {
            v = v && v.map(c => c.color);
            this.$refs.colorpicker.presetColors = v || defaultPresetColors;
        },
        value(v) {
            if (this.transparent && (v == null || v === '')) {
                this.colorObject = {
                    hex: 'None',
                    rgba: { r: 0, g: 0, b: 0, a: 0 },
                };
            } else {
                this.colorObject = {
                    hex: v || '#000000',
                    rgba: getRgba(v),
                };
            }
        },
    },
    methods: {
        onColorChanged(c) {
            this.colorObject = c;
            this.$emit('input', c.hex);
        },
        onclickPanel() {
            if (this.enabled === false) {
                return;
            }
            const el = this.$el;
            const pos = offsetPosition(el);
            const panel = this.$refs.colorpicker.$el;
            panel.style.left = `${pos.left}px`;
            const screenHeight = $(this.window || window).height();
            let top = pos.top + el.offsetHeight;
            const panelHeight = $(panel).height();
            if (top + panelHeight + 20 > screenHeight) {
                top = screenHeight - panelHeight - 20;
            }
            panel.style.top = `${top}px`;
            this.colorPanelVisible = true;
        },
        onmousedownWrapper() {
            this.colorPanelVisible = false;
        },
    },
};
</script>

<style scoped>
.selector {
    display: inline-block;
    vertical-align: bottom;
    height: 20px;
    line-height: 20px;
    border: 1px solid #aaa;
    border-radius: 2px;
    position: relative;
    cursor: default;
    background-color: white;
}
.selector:hover {
    border-color: #7f7f7f;
}
.color-block {
    float: left;
    width: 28px;
    height: 100%;
    box-sizing: border-box;
    padding: 4px 6px;
}
.color-block > div {
    position: absolute;
    width: 16px;
    top: 4px;
    bottom: 4px;
}
.color-block .color-block-bg {
    background-image: url('assets/alpha.png');
}
.color-block .color-block-cell {
    border: 1px solid rgba(127, 127, 127, 0.2);
    margin-top: -1px;
    margin-left: -1px;
    bottom: 3px;
}
.color-label {
    /* font-size: 0.875em; */
    /* vertical-align: top; */
    margin-right: 16px;
}
.color-drop {
    position: absolute;
    top: 50%;
    right: 4px;
    margin-top: -2px;
    width: 0;
    height: 0;
    border-top: 4px solid #000;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
}

.wrapper {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
}
.wrapper-color {
    margin-top: 6px;
    position: absolute;
    z-index: 1001;
}
</style>



// WEBPACK FOOTER //
// colorbox.vue?29c01295